import { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router';
import { useWindowSize } from 'react-use';

import { getCardsThunk, getOwnerBalanceThunk } from '../../store/slices/paymentsSlice';
// import { getStocks } from '../../api/stocksService';
// import {
//   setFetchError,
//   setFetchStatus,
//   setOrderedCount,
//   setReturnsCount,
//   setStocks,
//   setStorageCount,
// } from '../../store/slices/stocksSlice';
import { closePopup } from '../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { menuItems } from '../../utils/constants';
import Logo from '../Logo/Logo';
import SidebarInfoBlock from '../SidebarInfoBlock/SidebarInfoBlock';
import styles from './styles/styles.module.css';

function Sidebar() {
  const { width } = useWindowSize();
  const { pathname } = useLocation();
  const isBalanceMobile = width < 480 && pathname === '/balance';
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.data);

  // useEffect(() => {
  //   if (!pathname.includes('/add')) {
  //     getStocks({ status: 'stored' }).then((data) => {
  //       dispatch(setStorageCount({ total_count: data.stocks.length }));
  //     });
  //     getStocks({ status: 'returned' }).then((data) => {
  //       dispatch(setReturnsCount({ total_count: data.stocks.length }));
  //     });
  //     getStocks({ status: 'ordered' }).then((data) => {
  //       dispatch(setOrderedCount({ total_count: data.stocks.length }));
  //     });
  //     getStocks({ status: 'stored' })
  //       .then((data) => {
  //         dispatch(setStocks(data));
  //         dispatch(setFetchStatus('succeeded'));
  //       })
  //       .catch((err) => {
  //         console.error(err.message);
  //         dispatch(setFetchError(err.message));
  //         dispatch(setFetchStatus('failed'));
  //       });
  //   }
  // }, []);

  useEffect(() => {
    dispatch(getCardsThunk());
    dispatch(getOwnerBalanceThunk(user?.id));
  }, [dispatch, user?.id]);

  const step = useAppSelector((state) => state.stocks.step);
  const styleSideBarWrapper =
    (pathname.includes('orders/') ||
      (pathname.includes('refund') && step >= 1) ||
      pathname.includes('send')) &&
    width < 480
      ? styles.sidebarWrapperDis
      : styles.sidebarWrapper;
  const getNavLinkClass = ({ isActive }) =>
    isActive ? `${styles.navbarLink_active} ${styles.navbarLink}` : styles.navbarLink;
  useEffect(() => {
    console.log(width);
  }, [width]);
  let filtredMenuItems;

  if (width > 480) {
    filtredMenuItems = menuItems.filter(
      (item) => item.label !== 'Меню' && item.label !== 'Закрыть'
    );
  } else if (width < 480) {
    filtredMenuItems = menuItems.filter((item) => item.label !== 'Закрыть');
  } else {
    filtredMenuItems = menuItems;
  }
  return (
    <div
      className={styleSideBarWrapper}
      role="button" // Указываем роль
      tabIndex={0} // Делаем элемент фокусируемым
      onClick={() => {
        if (isBalanceMobile) dispatch(closePopup());
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          if (isBalanceMobile) dispatch(closePopup());
        }
      }}
    >
      {width < 480 ? '' : <Logo />}
      <nav className={styles.navbar}>
        <ul className={styles.navbarMenu}>
          {filtredMenuItems.map(({ path, label, src, activeSrc }) => (
            <li key={path}>
              <NavLink to={path} className={getNavLinkClass}>
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? activeSrc : src}
                      alt={label}
                      className={styles.navbarIcon}
                    />
                    <div className={styles.menuItemText}>
                      {width < 480 && label === 'Баланс и оплата' ? 'Баланс' : label}
                    </div>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      {width > 480 ? <SidebarInfoBlock /> : null}
    </div>
  );
}

export default Sidebar;
